import * as React from 'react';
import type { WrkthruItSeed } from 'shared/src/wrkthru/wrkthru-it-seed';
import { client } from '@/utils/trpc-client';
import { useAssistantStore } from './assistant-store';

export function useWrkthruAssistantLauncher() {
  const startLaunch = useAssistantStore(s => s.startLaunch);
  const finishLaunch = useAssistantStore(s => s.finishLaunch);

  return React.useCallback(
    (seed: WrkthruItSeed) => {
      const id = crypto.randomUUID();
      startLaunch(id);

      void client.assistantResolveWrkthruLaunch
        .mutate({
          title: seed.title,
          origin: seed.origin
        })
        .catch(() => ({
          conversationId: crypto.randomUUID(),
          mode: 'create' as const
        }))
        .then(resolution => {
          if (resolution.mode === 'resume') {
            finishLaunch({ id, status: 'select', conversationId: resolution.conversationId });
          } else {
            finishLaunch({
              id,
              status: 'send',
              conversationId: resolution.conversationId,
              seed
            });
          }
        });
    },
    [finishLaunch, startLaunch]
  );
}
